import axios from 'axios';

// 登录请求方法
const rawreq = (method, url, data) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/json',
        },
        data: data,
        traditional: true,
        transformRequest: [
          function(data) {
            return data
          }
        ],
    }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data)
};

// 导入 formData
const reqFormData = (method, url, params) => {
  return axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    data: params,
    traditional: true,
    transformRequest: [
      function(data) {
        return data
      }
    ],
  }).then(res => res.data)
};

// 下载 输出流格式文件
const csreq = (method, url, params) => {
  return axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: params,
    traditional: true,
    responseType: 'blob',
    transformRequest: [
      function(data) {
        let ret = ''
        for (let it in data) {
          ret +=
            encodeURIComponent(it) +
            '=' +
            encodeURIComponent(data[it]) +
            '&'
        }
        return ret
      }
    ]
  }).then(res => res.data)
};

// 下载 输出流格式文件 （raw传参）
const csrawreq = (method, url, params) => {
  return axios({
    method: method,
    url: url,
    headers: {
      'Content-Type': 'application/json'
    },
    data: params,
    traditional: true,
    responseType: 'blob',
    transformRequest: [
      function(data) {
        return data
      }
    ],
  }).then(res => res.data)
};

/*
*
* headers: {
      'Content-Type': 'application/json',
      token: localStorage.getItem('logintoken')
  },
*
* */

export {
  rawreq,
  req,
  csreq,
  csrawreq,

  reqFormData
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js